import React from 'react';

/**
 * High-visibility vector Page Break icon matching Microsoft Word / rich-text document standards.
 * Features a split document with an upper page section, a distinct dashed divider line,
 * and a lower page section.
 */
export function PageBreakIcon({ size = 19, style = {}, className = '', color = 'currentColor' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
      }}
    >
      {/* Top Page section */}
      <path d="M4 10V4a1.5 1.5 0 0 1 1.5-1.5h9l5.5 5.5v2" />
      <polyline points="14.5 2.5 14.5 8 20 8" />
      
      {/* Middle Page Break dashed indicator line */}
      <line x1="2" y1="12" x2="22" y2="12" strokeDasharray="3 2.5" strokeWidth="2.2" stroke="#2563eb" />
      
      {/* Bottom Page section */}
      <path d="M20 14v6a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 20v-6" />
    </svg>
  );
}

export default PageBreakIcon;
